import { withoutKey } from './utils.js';
export const applyAuthState = (authState) => (state) => {
    if (Object.keys(authState).length > 0) {
        return { ...state, ...authState };
    }
    return state;
};
export const withoutTokens = withoutKey('tokens');
export const withoutMimicToken = withoutKey('mimicToken');
export const selectTokens = (state) => state.tokens;
export const selectMimicToken = (state) => state.mimicToken;
